import { z } from 'zod';

export const routeFormSchema = z.object({
  routeId: z
    .string()
    .min(1, 'Please select a route')
    .refine((id): id is `route-${string}` => id.startsWith('route-')),
});

export type RouteFormData = z.infer<typeof routeFormSchema>;
